const EMAIL_TYPE_OPTIONS = [
   {
      value: 0,
      label: 'All',
      id: 0,
      name: 'All',
   },
   {
      value: 1,
      label: 'Accounts',
      id: 1,
      name: 'Accounts',
   },
   {
      value: 2,
      label: 'Billing',
      id: 2,
      name: 'Billing',
   },
   {
      value: 3,
      label: 'Candidates',
      id: 3,
      name: 'Candidates',
   },
   {
      value: 4,
      label: 'Jobs',
      id: 4,
      name: 'Jobs',

   },
];

export default EMAIL_TYPE_OPTIONS;
